import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function ContactUs() {
  const [formData, setFormData] = useState({ name: "", phone: "", email: "" });
  const navigate = useNavigate();

  const handleNameChange = (e) => {
    const value = e.target.value;
    if (/^[A-Za-z\s]*$/.test(value)) {
      setFormData({ ...formData, name: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, phone, email } = formData;

    if (!/^[A-Za-z\s]+$/.test(name)) {
      toast.error("Please enter a valid name (letters only).");
      return;
    }
    if (phone.length < 10) {
      toast.error("Please enter a valid phone number.");
      return;
    }
    if (!email.includes("@")) {
      toast.error("Please enter a valid email address.");
      return;
    }

    try {
      const res = await fetch("/contact.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, phone, email }),
      });

      const text = await res.text();
      if (res.ok) {
        toast.success(text || "Form submitted successfully!");
        setTimeout(() => navigate("/thank-you"), 1500);
      } else {
        toast.error(text || "Something went wrong!");
      }
    } catch (err) {
      toast.error("Error submitting form. Please try again.");
    }
  };

  return (
    <div id="contact" className=" bg-[#fdf6f6] py-10 w-full">
      <form
        onSubmit={handleSubmit}
        className="max-w-6xl mx-auto bg-[#fff] shadow-xl rounded-2xl p-8 font-inter text-[15px] text-[#000000d9]"
      >
        {/* Horizontal Row: Inputs + Button */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {/* Name Field */}
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleNameChange}
            placeholder="Your Name"
            className="w-full bg-transparent border-b-2 border-[#c55b12] outline-none py-2"
            required
          />

          {/* Phone Field */}
          <PhoneInput
            country={"in"}
            value={formData.phone}
            onChange={(value) => setFormData({ ...formData, phone: value })}
            enableSearch
            containerClass="w-full border-b-2 border-[#c55b12] pb-[2px] flex items-center"
            inputClass="!w-full !bg-transparent !border-none !outline-none !shadow-none !h-[44px] !py-2"
            buttonClass="!bg-transparent !border-none !h-[44px] !flex !items-center"
            dropdownStyle={{ zIndex: 50 }}
            dropdownClass="custom-phone-dropdown"
            required
          />

          {/* Email Field */}
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
            placeholder="Email"
            className="w-full bg-transparent border-b-2 border-[#c55b12] outline-none py-2"
            required
          />

          {/* Submit Button in Same Line */}
          <button
            type="submit"
            className="px-6 py-3 bg-[#c55b12] text-white rounded-xl font-inter w-full hover:shadow-lg md:mt-0 mt-4"
          >
            Download Brochure
          </button>
        </div>
      </form>
    </div>
  );
}
